import { ReactNode } from 'react';
import styled from 'styled-components';
import { textSmall } from 'styles-js/mixins/typography';
import TextInput from 'src/components/inputs/textInput';

type Props = {
  dataTestId?: string;
  id: string;
  label?: string;
  labelExtra?: string;
  link?: ReactNode;
  meta: { touched: boolean, error: string };
  placeholder: string;
  type: 'text' | 'password' | 'email';
  value: string;
  onBlur: (e) => void;
  onChange: (e) => void;
}
export default function ValidatedTextInput({
  dataTestId,
  id,
  label,
  labelExtra,
  link,
  meta: { touched, error },
  placeholder,
  type,
  value,
  onBlur,
  onChange,
}: Props): JSX.Element {
  return (
    <>
      <Label>
        {label && (
          <label htmlFor={id}>
            {label} {labelExtra && <span className="label-subtitle">{labelExtra}</span>}
          </label>
        )}
        {link}
      </Label>
      <TextInput
        dataTestId={dataTestId}
        id={id}
        placeholder={placeholder}
        specialClass={touched && !error ? 'has-success' : ''}
        type={type}
        validationErrors={touched && !!error ? [error] : []}
        value={value}
        onBlur={onBlur}
        onChange={onChange}
      />
    </>
  );
}

const Label = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  label {
    ${textSmall}
    margin-top: 10px;
    margin-bottom: 0;
    font-weight: ${({ theme }) => theme.fontWeightBold};
  }
`;
